import html2canvas from "html2canvas";

export const exportAsImage = async (elementId, fileName) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  // Save current styles
  const originalOverflow = element.style.overflow;
  const originalWidth = element.style.width;

  // Track hidden elements for restore
  const hidden = [];
  element.querySelectorAll(".no-export").forEach((el) => {
    hidden.push({ el, display: el.style.display });
    el.style.display = "none"; // hide for export
  });

  try {
    // Expand container to full scroll width
    element.style.overflow = "visible";
    element.style.width = element.scrollWidth + "px";

    const canvas = await html2canvas(element, {
      useCORS: true,
      scrollX: 0,
      scrollY: -window.scrollY,
      width: element.scrollWidth,
      height: element.scrollHeight,
    });

    const dataUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `${fileName}.png`;
    link.click();
  } finally {
    // Restore hidden elements
    hidden.forEach(({ el, display }) => {
      el.style.display = display;
    });

    // Restore original styles
    element.style.overflow = originalOverflow;
    element.style.width = originalWidth;
  }
};
